import { BaseProxy } from "@/proxies/BaseProxy";

export class LogoutProxy extends BaseProxy {
  constructor({ parameters = {} } = {}) {
    super({
      endpoint: `logout`,
      parameters,
    });
  }
}
